import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ServerApi } from './api.services/server.api';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MapService {
  public multiplePlacemarksChange: Subject<any> = new Subject<any>();
  public multipleSitesChange: Subject<any> = new Subject<any>();
  public mapLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private readonly serverApi: ServerApi) {}

  load(): Observable<string> {
    const mapsApiKeyUrl = `${environment.serverUrl}/newapi/mapapikey`;
    return this.serverApi.sendGetToServer(mapsApiKeyUrl);
  }

  public setMultiplePlacemarkMenuOptions(placemarks: any[] = [], position?) {
    this.multiplePlacemarksChange.next({multiplePlacemarks: placemarks, position: position});
  }

  public setMultipleSitesMenuOptions(sites: any[] = [], position?) {
    this.multipleSitesChange.next({multipleSites: sites, position: position});
  }
}
        